export const initialLabel = {
  roleLevel: "Role Level",
  systemRoleName: "System Role Name",
  systemDescription: "System Role Name Description",
  displayRoleName: "Display Role Name",
  displayDescription: "Display Role Name Description",
};

export const intialObj = {
  systemRoleName: "",
  systemDescription: "",
  displayRoleName: "",
  displayDescription: "",
};

export const initialRules = [
  {
    field_name: "systemRoleName",
    label: initialLabel.systemRoleName,
    type: "String",
    isRequired: true,
  },
  // {
  //   field_name: "systemDescription",
  //   label: initialLabel.systemDescription,
  //   type: "String",
  //   isRequired: true,
  // },
  {
    field_name: "displayRoleName",
    label: initialLabel.displayRoleName,
    type: "String",
    isRequired: true,
  },
  // {
  //   field_name: "displayDescription",
  //   label: initialLabel.displayDescription,
  //   type: "String",
  //   isRequired: true,
  // },
];
